import { render } from "./ComentariosFiltro_sap.vue?vue&type=template&id=d3ad48b2&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"personal\":\"data\",\"asignarValor\":\"options\",\"asignarSector\":\"options\",\"obtenerPersonal\":\"options\",\"refrescarPersonal\":\"options\"}"
import script from "./ComentariosFiltro_sap.vue?vue&type=script&lang=js"
export * from "./ComentariosFiltro_sap.vue?vue&type=script&lang=js"
script.render = render

export default script